import apiSettings from '../../config/api';
import routeSettings from '../../config/router';
import request from '../../utils/request/index';
import actionTypes from './ActioTypes';

const getTourById = (tourId, history) => {
  const url = apiSettings.endpoints.genGetTourByIdUrl();
  return dispatch => {
    request
      .post(url, {tourId}, dispatch, actionTypes.GET_TOUR_BY_ID)
      .then((res) => {
        dispatch({type: actionTypes.GET_TOUR_BY_ID.fulfilled, data: res.data});
        if(history){
          history.push(`${routeSettings.tourPage}/${tourId}`)
        }
      })
  }
};

const pageUnmounted = () => {
  return dispatch => {
    dispatch({type: actionTypes.TOUR_PAGE_UN_MOUNTED})
  }
};

export {getTourById, pageUnmounted}


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/Actions.js